module.exports = __webpack_public_path__ + "static/media/29ADMSPC3.c76ad2b7.jpg";